import { IImageProps } from "@/lib/types/components";
import * as S from "./styles.ts";
import { Button, H5, Image, P, UniversalLink } from "@template/components";
import ChevronRight from "@template/icons/ChevronRight.tsx";
import { IButtonProps } from "@template/components/Button";

export type TBentoBox = {
  heading?: string;
  description?: string;
  image?: IImageProps;
  reverse?: boolean;
  cta?: {
    text: string;
    href?: string;
    target?: "_blank" | "_self";
  };
  button?: IButtonProps;
  width: number;
  height: number;
  alternativeStyling?: boolean;
};

interface IBox {
  box: TBentoBox;
  borderRadius: number;
  gap: number;
}

const BentoBox = ({
  box: {
    heading,
    description,
    image,
    cta,
    button,
    width,
    height,
    alternativeStyling,
    reverse,
  },
  borderRadius,
  gap,
}: IBox) => {
  return (
    <S.Wrapper
      $alternativeStyling={alternativeStyling}
      $width={width}
      $height={height}
      $gap={gap}
      $borderRadius={borderRadius}
      $reverse={reverse}
    >
      {(heading || description || cta?.text || button?.children) && (
        <S.ContentWrapper>
          <S.Content>
            {heading && <H5>{heading}</H5>}
            {description && <P>{description}</P>}
            {cta?.text && (
              <UniversalLink
                href={cta.href || "#"}
                styled
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                {cta.text}
                <ChevronRight />
              </UniversalLink>
            )}
            {button?.children && <Button {...button} />}
          </S.Content>
        </S.ContentWrapper>
      )}
      {image?.src && (
        <Image
          src={image.src}
          alt={image.alt}
        />
      )}
    </S.Wrapper>
  );
};

export default BentoBox;
